import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';

import Styled from './styles';

export interface HyperlinkProps extends React.ComponentPropsWithRef<'a'> {
  /**
   * To render the content of the Hyperlink
   */
  children: React.ReactNode;
  /** Disables the link. */
  disabled?: boolean;
  /** To override the Hyperlink theme. Please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** `Hyperlink`, all other props will be provided to the root DOM element. */
const Hyperlink = React.forwardRef<HTMLElement, HyperlinkProps>((props: HyperlinkProps, ref) => getContext(({ RTL, theme }) => {
  const {
    theme: propTheme,
    children,
    disabled,
    ...otherProps
  } = props;

  const resolvedTheme = _merge({}, theme, propTheme);

  return (
    <Styled.Anchor
      ref={ref}
      theme={resolvedTheme.HYPERLINK}
      disabled={disabled}
      {...otherProps}
    >
      <Styled.ContentWrapper $rtl={RTL}>
        {children}
      </Styled.ContentWrapper>
    </Styled.Anchor>
  );
}));

Hyperlink.displayName = 'Hyperlink';

Hyperlink.defaultProps = {
  disabled: false,
  theme: {}
};


export default Hyperlink;
